class AppPerformanceModel {
  constructor({
    battery_low_power_mode = null,
    battery_percentage = null,
    battery_seconds_to_charged = null,
    battery_seconds_to_discharged = null,
    battery_is_charging = null,
    data_down_kb = null,
    data_up_kb = null,
  } = {}) {
    this.battery_low_power_mode = battery_low_power_mode;
    this.battery_percentage = battery_percentage;
    this.battery_seconds_to_charged = battery_seconds_to_charged;
    this.battery_seconds_to_discharged = battery_seconds_to_discharged;
    this.battery_is_charging = battery_is_charging;
    this.data_down_kb = data_down_kb;
    this.data_up_kb = data_up_kb;
  }

  json() {
    return {
      battery_low_power_mode: this.battery_low_power_mode,
      battery_percentage: this.battery_percentage,
      battery_seconds_to_charged: this.battery_seconds_to_charged,
      battery_seconds_to_discharged: this.battery_seconds_to_discharged,
      battery_is_charging: this.battery_is_charging,
      data_down_kb: this.data_down_kb,
      data_up_kb: this.data_up_kb,
    };
  }
}

module.exports = AppPerformanceModel;
